import { registerPlugin } from '@capacitor/core';

export interface DispatchAlertPlugin {
  ensureDispatchChannel(): Promise<void>;
  playAlarm(): Promise<void>;
  stopAlarm(): Promise<void>;
}

export const DispatchAlert = registerPlugin<DispatchAlertPlugin>('DispatchAlert');
